import type { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getIndustryListData, getIndustryOverviewData } from './mockData'
import type { IIndustryOverview } from '~/types/industry/models'
import type { ISelectItem } from '~/types/models'

// get

interface GetIndustriesResponse {
  data: ISelectItem[]
}

async function getIndustries(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetIndustriesResponse = {
    data: await getIndustryListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetIndustryOverviewResponse {
  data: IIndustryOverview
}

async function getOverviewById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const obj = await getIndustryOverviewData(id)
  if (obj) {
    console.log(`Returning overview for industry "${id}"`)
    const responseBody: GetIndustryOverviewResponse = {
      data: obj,
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } else {
    const responseBody = { statusCode: 404, message: 'Resource not found.' }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postIndustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getIndustryListData)
}

const patchIndustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getIndustryListData)
}

const deleteIndustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getIndustryListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/industries',
    handler: getIndustries,
  },
  {
    method: 'get',
    path: '/api/industries/:id/overview',
    handler: getOverviewById,
  },
  {
    method: 'post',
    path: '/api/industries',
    handler: postIndustry,
  },
  {
    method: 'patch',
    path: '/api/industries/:id',
    handler: patchIndustry,
  },
  {
    method: 'delete',
    path: '/api/industries/:id',
    handler: deleteIndustry,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
